/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ProviderDocumentAnalysisStatus {

    PENDING = 'PENDING',

    EXTRACTING = 'EXTRACTING',

    READY = 'READY',

    FAILED = 'FAILED'
}

